import axios, { AxiosResponse } from "axios";
import { ApiResult, AxiosErr } from "../Contracts/IMdels";
import { BaseModel } from "./BaseModel";

export class MelkMalekModel extends BaseModel {
  RouteName = "MelkMalek";
  protected AuthState: boolean = true;

  public async GetAll() {
    try {
      return await this.baseApi.axiosInstance(this.AuthState).get(`${this.RouteName}`);
    } catch (e: any) {
      const error = e as AxiosErr;
      if (axios.isCancel(error)) {
        throw error.message;
      }

      throw error.response?.data.message;
    }
  }
  public async SubmitData(data: any) {
    try {
      return await this.baseApi.axiosInstance(this.AuthState).post(`${this.RouteName}`, data);
    } catch (e: any) {
      const error = e as AxiosErr;
      if (axios.isCancel(error)) {
        throw error.message;
      }
      throw error.response?.data.message;
    }
  }
  public async EditData(data: any) {
    try {
      return await this.baseApi.axiosInstance(this.AuthState).put(`${this.RouteName}/?Id=${data.id}`, data);
    } catch (e: any) {
      const error = e as AxiosErr;
      if (axios.isCancel(error)) {
        throw error.message;
      }
      throw error.response?.data.message;
    }
  }
  public async GetSearch(
    ShomParvande = "",
    MalekName = "",
    FamilyName = "",
    FatherName = "",
    CodeMeli = "",
    ShShenasname = "",
    CodePosti = "",
    ShMobile = "",
    Mantaghe = "",
    Hoze = "",
    Blook = "",
    CodeMelk = ""
  ) {
    try {
      return await this.baseApi
        .axiosInstance(this.AuthState)
        .get(
          `${this.RouteName}/search?ShomParvande=${ShomParvande}&MalekName=${MalekName}&FamilyName=${FamilyName}&FatherName=${FatherName}&CodeMeli=${CodeMeli}&ShShenasname=${ShShenasname}&CodePosti=${CodePosti}&ShMobile=${ShMobile}&Mantaghe=${Mantaghe}&Hoze=${Hoze}&Blook=${Blook}&CodeMelk=${CodeMelk}`
        );
    } catch (e: any) {
      const error = e as AxiosErr;
      if (axios.isCancel(error)) {
        throw error.message;
      }
      throw error.response?.data.message;
    }
  }
  public async ChangeStatus(id: number) {
    try {
      return await this.baseApi.axiosInstance(this.AuthState).post(`${this.RouteName}/Status/${id}`);
    } catch (e: any) {
      const error = e as AxiosErr;
      if (axios.isCancel(error)) {
        throw error.message;
      }
      throw error.response?.data.message;
    }
  }
}
